import { Component, Input, Output, OnInit, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import {FilterAbstractModel} from '../../../../models/FilterAbstractModel';

@Component({
  selector: 'app-service-country-filter',
  templateUrl: './service-country-filter.component.html',
  styleUrls: ['./service-country-filter.component.scss']
})
export class ServicesCountryFilterComponent extends FilterAbstractModel implements OnInit, OnChanges, OnDestroy {
 
  listFilterData: any[];
  optionSelected: any = null;

  @Input() servicesCountryData: any;
  @Input() servicesCountrySelected: any;
                      
  constructor() {
    super();
  }

  ngOnInit(): void { }

  ngOnChanges(changes: SimpleChanges): void {
    if ('servicesCountryData' in changes) {
      this.listFilterData = this.servicesCountryData ? this.servicesCountryData : [];
      this.ensureSelectedValueInList();
      if (!this.optionSelected && !this.servicesCountrySelected) {
        this.optionSelected = null;
      }
    }
    if ('servicesCountrySelected' in changes) {
      this.optionSelected = this.servicesCountrySelected || null;
      this.ensureSelectedValueInList();
    }
  }

  private ensureSelectedValueInList(): void {
    if (this.optionSelected && this.listFilterData && this.listFilterData.length > 0) {
      if (!this.listFilterData.includes(this.optionSelected)) {
        this.listFilterData = [...this.listFilterData, this.optionSelected];
      }
    }
  }

  ngOnDestroy(): void { }

}
